module.exports = __webpack_public_path__ + "media/images/menu/libra-7e0a2994ea6b3483f09def8a54137461.jpg";